import axios from 'axios';
import { authActions } from './store/auth/auth.actions';
import { store } from './store';

const handleResponse = (response) => response;

const handleError = (err) => {
  if (err.response && err.response.status === 418) {
    return err.response;
  } else if (
    err.response
    && err.response.status === 401
    && !(
      err.response.request
      && (err.response.request.responseURL.includes('/login')
        || err.response.request.responseURL.includes('/change_password')
        || err.response.request.responseURL.includes('/set_new_password'))
    )
  ) {
    store.dispatch(authActions.logout());
    return err.response;
  } else {
    return Promise.reject(err);
  }
};

export const axiosInstanceLongTimeout = axios.create();
axiosInstanceLongTimeout.defaults.timeout = 80000;
axiosInstanceLongTimeout.interceptors.response.use(
  handleResponse,
  handleError,
);

const axiosInstance = axios.create();

axiosInstance.defaults.timeout = 40000;
axiosInstance.interceptors.response.use(
  handleResponse,
  handleError,
);

axiosInstance.interceptors.request.use(
  (request) => {
    if (localStorage.getItem('impersonateUsername')) {
      const existing = request.params || {};
      request.params = {
        ...existing,
        impersonateUsername: localStorage.getItem('impersonateUsername'),
      };
    }
    return request;
  },
  (err) => Promise.reject(err),
);

axiosInstanceLongTimeout.interceptors.request.use(
  (request) => {
    if (localStorage.getItem('impersonateUsername')) {
      const existing = request.params || {};
      request.params = {
        ...existing,
        impersonateUsername: localStorage.getItem('impersonateUsername'),
      };
    }
    return request;
  },
  (err) => Promise.reject(err),
);

export default axiosInstance;
